var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4868AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5249 15.5474C19.5005 15.804 19.2849 16 19.0271 16H16.4571V23.5C16.4571 23.7761 16.2333 24 15.9571 24H13.4139C13.1378 24 12.9139 23.7761 12.9139 23.5V16H11.167C10.8909 16 10.667 15.7761 10.667 15.5V13.8626C10.667 13.5865 10.8908 13.3626 11.167 13.3626H12.9139V11.6044C12.9139 9.31868 13.8645 8 16.4571 8H19.5003C19.7765 8 20.0003 8.22386 20.0003 8.5V10.2253C20.0003 10.5014 19.7765 10.7253 19.5003 10.7253H17.5806C16.5435 10.7253 16.4571 11.0769 16.4571 11.7802V13.2747H19.1912C19.4861 13.2747 19.7169 13.5286 19.689 13.8221L19.5249 15.5474Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0f08077b20e11964f9e9e7d19a55f2d1.svg";
export { ForwardRef as ReactComponent };